import * as React from 'react';

function SvgResizeFull(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 23.89" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M11.8 14.43a.46.46 0 01-.16.36l-5.19 5.14 2.25 2.24a.94.94 0 01.34.76 1 1 0 01-.3.7 1 1 0 01-.7.3h-7a1 1 0 01-.7-.29 1 1 0 01-.3-.71v-7a.94.94 0 01.3-.7 1 1 0 01.7-.3 1 1 0 01.71.3L4 17.47l5.14-5.17a.53.53 0 01.36-.15.49.49 0 01.36.15l1.78 1.78a.46.46 0 01.16.35zM24.04.99v6.94a1 1 0 01-1 1 1 1 0 01-.7-.3l-2.3-2.21-5.19 5.17a.49.49 0 01-.36.15.53.53 0 01-.36-.15l-1.77-1.78a.49.49 0 01-.15-.35.49.49 0 01.15-.36l5.19-5.17-2.25-2.24a.94.94 0 01-.3-.7 1 1 0 01.3-.7 1 1 0 01.74-.29h7a1 1 0 01.7.29 1 1 0 01.3.7z" />
    </svg>
  );
}

const MemoSvgResizeFull = React.memo(SvgResizeFull);
export default MemoSvgResizeFull;
